import { render } from "./ModalNotification.vue?vue&type=template&id=6a766de0"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__